import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=843ed9b8&scoped=true&"
import script from "./PdfViewer.js?vue&type=script&lang=js&"
export * from "./PdfViewer.js?vue&type=script&lang=js&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=843ed9b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843ed9b8",
  null
  
)

export default component.exports